export const pageConfig = {
  pageSize: 12,
};

export const getTotalPages = (totalRecords: number) =>
  totalRecords > 0 ? Math.ceil(totalRecords / pageConfig.pageSize) : 1;

export const getPageNumberFrom = (pageNumber?: string | undefined) => {
  const resolvedPageNumber = Number(pageNumber) ?? 1;
  if (isNaN(resolvedPageNumber)) return 1;
  return resolvedPageNumber;
};

export const getRecordsToSkip = (pageNumber?: number | string | undefined) => {
  const resolvedPageNumber =
    typeof pageNumber === 'number' ? pageNumber : getPageNumberFrom(pageNumber);
  return (resolvedPageNumber - 1) * pageConfig.pageSize;
};

export const showPagination = (totalRecords: number = 0) =>
  totalRecords > pageConfig.pageSize;
